import Vue from 'vue'

// import {
//   Button,
//   Cell
// } from 'mint-ui'

// Vue.component(Button.name, Button)
// Vue.component(Cell.name, Cell)
import App from './App.vue'
import router from './router'
import store from './store'
import {
	myFixed
} from './utils/cal';

/* 或写为
 * Vue.use(Button)
 * Vue.use(Cell)
 */
import '@/assets/stylus/index.styl';

import 'amfe-flexible';

import './vant.js'

Number.prototype.myFixed = function (d) {
	return myFixed(this, d)
}

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
